import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { IconType } from "@/types/icons";
import { getIconPath } from "@/utils/app/getIconPath";
import { computed } from "vue";

interface Props {
  icon: IconType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    icon: {}
  },
  setup(__props: any) {

const props = __props;
const src = computed(() => getIconPath(props.icon));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", { src: src.value }, null, 8, _hoisted_1))
}
}

})